import { BaseRouteService } from 'core/services';

class AlertsRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'alerts/';
	}

    getRunningJobs() {
        return super.get(this.base + 'get-running-jobs');
    }
    
	getAllScheduledJobLogs() {
        return super.get(this.base + 'get-all-scheduled-job-logs');
	}

	getScheduledJobEstimates() {
		return super.get(this.base + 'get-job-estimates');
	}
}
export default AlertsRouteService;
